import client from './client';
import type { CallRecord } from '../store/useCallStore';

// 202-Antwort des Backends: großer Zeitraum wird gerade erstmalig vom SBC geladen.
// `calls` enthält bereits den Teilstand (neueste Daten zuerst), `progress` den
// Füll-Fortschritt — kurz darauf erneut anfragen, bis warming verschwindet.
export interface WarmingProgress {
  fetchedRows: number;
  coveredFrom: string | null;
  percent: number | null;
  etaSeconds: number | null;
}

export interface CallHistoryWarming {
  warming: true;
  calls?: CallRecord[];
  progress?: WarmingProgress;
}

export function isWarming(data: CallRecord[] | CallHistoryWarming): data is CallHistoryWarming {
  return !Array.isArray(data) && data?.warming === true;
}

export interface CallHistoryQuery {
  period: string;
  count: number;
  fields?: string[];
  missedOnly?: boolean;
  /** Volltextsuche serverseitig über den ganzen Zeitraum (nicht nur die Anzeige-Seite). */
  search?: string;
  /** Admin-only: Sicht eines Unternehmens einnehmen. */
  viewAsCompanyId?: string | null;
}

export async function fetchCallHistory(query: CallHistoryQuery): Promise<CallRecord[] | CallHistoryWarming> {
  const { data } = await client.post<CallRecord[] | CallHistoryWarming>('/api/callhistory', {
    filterDateTimePeriod: query.period,
    filterCount: query.count,
    ...(query.fields && query.fields.length > 0 ? { fields: query.fields } : {}),
    ...(query.missedOnly ? { missedOnly: true } : {}),
    ...(query.search?.trim() ? { search: query.search.trim() } : {}),
    ...(query.viewAsCompanyId ? { viewAsCompanyId: query.viewAsCompanyId } : {}),
  });
  return data;
}

export async function fetchAvailableFields(): Promise<string[]> {
  const { data } = await client.get<string[]>('/api/callhistory/fields');
  return data;
}
